import { connect } from 'react-redux';
import { SubmissionError, change, untouch } from 'redux-form';
import { browserHistory } from 'react-router';
import { processSubscriber, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import validate from '../components/Validations/submitValidationsMainForm'
import { getErrorsApiToReduxForm, getQueryString, sanetizeMktParams } from '../utils/utils.js';
import MainForm from '../components/MainForm.js';

const mapStateToProps = (state) => {

    return {
        isValidating: false,
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        //For any field errors upon submission (i.e. not instant check)
        addSubscriber(values, dispatch, ownProps) {
            dispatch(submitForm());
            let errors = validate(values);
            if( Object.keys(errors).length !== 0){
                const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
                return sleep(10).then(() => {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError({ ...errors, _error: 'Revisá los campos indicados.' })
                })
            }
            return dispatch(processSubscriber({ ...values, tracking: sanetizeMktParams(ownProps.location.query) })).then((result) => {
                    // Note: Error's "data" is in result.payload.response.data (inside "response")
                    // success's "data" is in result.payload.data{}
                    if (result.payload.response && result.payload.response.status !== 200) {
                        dispatch(stopSubmitForm());
                        throw new SubmissionError({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'})
                    }

                    //let other components know that everything is fine by updating the redux` state
                    let extraParams = (typeof(result.payload.data.extra) !== 'undefined') ? result.payload.data.extra : false;
                    let providerSlug = (typeof(result.payload.data.body.name) !== 'undefined') ? result.payload.data.body.name : false;
                    let isRecurrent = (typeof(result.payload.data.body.recurrent) !== 'undefined') ? result.payload.data.body.recurrent : false;
                    let sanetizedString = {};
                    if (!isRecurrent){
                        sanetizedString = {...extraParams, pv: providerSlug}
                    } else {
                        sanetizedString = {untracked: true, ...extraParams, pv: providerSlug}
                    }

                    if(result.payload.data.leads){
                        //Store JWT Token to browser session storage
                        //If you use localStorage instead of sessionStorage, then this w/ persisted across tabs and new windows.
                        //sessionStorage = persisted only in current tab
                        sessionStorage.setItem('jwtToken', result.payload.data.body.access_token);
                        localStorage.removeItem('sanitizedName');
                        localStorage.removeItem('formName');
                        localStorage.setItem('formName', values.name);

                        dispatch(getNextStep()).then((result) => {
                            if (typeof(result.payload.data.endpoint) !== 'undefined') {
                                sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                                dispatch(stopSubmitForm());
                                browserHistory.push({
                                    pathname: result.payload.data.endpoint,
                                    search: getQueryString(sanetizedString),
                                });
                            }
                        });
                    } else {
                        browserHistory.push({
                                    pathname: '/disapproved',
                                    search: getQueryString(sanetizedString),
                        });
                    }

            });
        },
        deleteReduxFormField(fieldName){
            dispatch(change('IncomesForm', fieldName, null));
            dispatch(untouch('IncomesForm', fieldName));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainForm);



/** WEBPACK FOOTER **
 ** ./src/containers/MainFormContainer.js
 **/